const TOP_MENU_HEIGHT = 70;
export { TOP_MENU_HEIGHT };
